(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ac-restock-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'ac-restock-submitted';

    function currentVariantId(scope) {
      var el = scope.querySelector('[data-variants]');
      return el ? String(el.value) : null;
    }

    function setState(box, state, html) {
      var status = box.querySelector('[data-restock-status]');
      box.setAttribute('data-restock-state', state || '');
      if (typeof html === 'string') status.innerHTML = html;
    }

    function update(box) {
      if (box.getAttribute('data-restock-state') === 'success') { box.hidden = false; return; }
      var id = currentVariantId(document.querySelector('[data-product-form]') || document);
      var availability = {};
      try { availability = JSON.parse(box.getAttribute('data-restock-availability') || '{}'); } catch (_) {}
      if (!id || id === 'not-selected' || !(id in availability)) { box.hidden = true; return; }
      box.hidden = availability[id] !== false;
      var tags = box.querySelector('[data-restock-tags]');
      if (tags) tags.value = 'restock,restock:' + id;
    }

    function init() {
      var box = document.querySelector('[data-restock]');
      if (!box) return;

      // Returned from a submit? Shopify redirects back here after its spam check.
      // Belt and braces: URL flag (server-rendered) OR the flag we stored before leaving.
      var submitted = null;
      try { submitted = sessionStorage.getItem(KEY); } catch (_) {}
      var urlSaysSuccess = /[?&](restock=1|customer_posted=true)/.test(location.search);
      if (urlSaysSuccess || submitted) {
        setState(box, 'success', "<strong>You're on the list.</strong> We'll email you the moment this is back in stock.");
        try { sessionStorage.removeItem(KEY); } catch (_) {}
        box.hidden = false;
        setTimeout(function () { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
      }

      update(box);
      document.addEventListener('change', function (e) {
        if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-variants')) update(box);
      });
      var atc = document.querySelector('[data-product-atc]');
      if (atc && window.MutationObserver) {
        new MutationObserver(function () { update(box); }).observe(atc, { attributes: true, attributeFilter: ['disabled', 'class'] });
      }

      var form = box.querySelector('[data-restock-form]');
      var email = box.querySelector('[data-restock-email]');
      var label = box.querySelector('[data-restock-submit-label]');
      if (!form) return;

      email.addEventListener('input', function () { if (box.getAttribute('data-restock-state') === 'error') setState(box, '', ''); });

      // Native submit on purpose: Shopify's spam protection attaches its CAPTCHA token to a real
      // form post (an AJAX post is rejected). We validate first so the user gets instant feedback.
      form.addEventListener('submit', function (e) {
        var value = (email.value || '').trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
        if (!ok) {
          e.preventDefault();
          setState(box, 'error', 'That email address doesn’t look right — please check it and try again.');
          email.focus();
          return;
        }
        try { sessionStorage.setItem(KEY, value); } catch (_) {}
        box.classList.add('is-pending');
        if (label) label.textContent = 'Signing you up…';
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["complementary-products"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartRequest = null;

    function getCart() {
      if (!cartRequest) {
        cartRequest = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .finally(function () { cartRequest = null; });
      }
      return cartRequest;
    }

    function qtyInCart(cart, variantId) {
      return cart.items
        .filter(function (i) { return String(i.variant_id) === String(variantId); })
        .reduce(function (n, i) { return n + i.quantity; }, 0);
    }

    function render(box, qty) {
      box.querySelector('[data-addon-qty]').textContent = qty;
      box.querySelector('[data-addon-add]').hidden = qty > 0;
      box.querySelector('[data-addon-stepper]').hidden = qty <= 0;
      box.querySelector('[data-addon-cart]').hidden = qty <= 0;
      box.dataset.qty = qty;
    }

    function broadcast(cart) {
      try { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); } catch (_) {}
    }

    function setQty(box, qty) {
      if (box.classList.contains('is-pending')) return;
      var status = box.querySelector('[data-addon-status]');
      var current = parseInt(box.dataset.qty || '0', 10);
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      box.classList.add('is-pending');
      status.textContent = '';
      var req = (current === 0 && qty > 0)
        ? fetch(root + 'cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: [{ id: Number(box.dataset.variantId), quantity: qty }] }) })
        : fetch(root + 'cart/change.js', { method: 'POST', headers: headers, body: JSON.stringify({ id: String(box.dataset.variantId), quantity: qty }) });
      req
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || box.dataset.error); return j; }); })
        .then(function () { return getCart(); })
        .then(function (cart) { render(box, qtyInCart(cart, box.dataset.variantId)); broadcast(cart); })
        .catch(function (err) { status.textContent = (err && err.message) || box.dataset.error; })
        .finally(function () { box.classList.remove('is-pending'); });
    }

    function init() {
      var boxes = document.querySelectorAll('[data-addon]');
      if (!boxes.length) return;
      getCart().then(function (cart) {
        boxes.forEach(function (box) { render(box, qtyInCart(cart, box.dataset.variantId)); });
      }).catch(function () {});
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-addon-add], [data-addon-plus], [data-addon-minus]');
      if (!btn) return;
      var box = btn.closest('[data-addon]');
      if (!box) return;
      event.preventDefault();
      var current = parseInt(box.dataset.qty || '0', 10);
      setQty(box, btn.hasAttribute('data-addon-minus') ? Math.max(0, current - 1) : current + 1);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
